import {
	collection,
	getDocs
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

const calcularEstado = (dominio) => {

	if (dominio >= 90) return "dominado";

	if (dominio >= 70) return "estable";

	if (dominio >= 50) return "inestable";

	return "critico";
};

const calcularTendencia = (
	ultimosResultados = []
) => {

	if (!ultimosResultados.length) {
		return "sin_datos";
	}

	const aciertos =
		ultimosResultados.filter(
			(r) => r === true
		).length;

	const porcentaje =
		(aciertos /
			ultimosResultados.length) *
		100;

	if (porcentaje >= 80) {
		return "mejorando";
	}

	if (porcentaje >= 50) {
		return "estable";
	}

	return "empeorando";
};

export const obtenerDiagnosticoUsuario =
async (userId) => {

	const [
		progresoSnap,
		temasSnap,
		temaCompSnap,
		componentesSnap,
		examenesSnap
	] = await Promise.all([

		getDocs(
			collection(
				db,
				"progreso_temas"
			)
		),

		getDocs(
			collection(
				db,
				"materias_temas"
			)
		),

		getDocs(
			collection(
				db,
				"tema_componente"
			)
		),

		getDocs(
			collection(
				db,
				"componentes"
			)
		),

		getDocs(
			collection(
				db,
				"examenes"
			)
		)
	]);

	const progresoTemas =
		progresoSnap.docs
			.map((d) => d.data())
			.filter(
				(d) =>
					d.userId === userId
			);

	const temas =
		temasSnap.docs.map(
			(d) => d.data()
		);

	const temaComponentes =
		temaCompSnap.docs.map(
			(d) => d.data()
		);

	const componentes =
		componentesSnap.docs.map(
			(d) => d.data()
		);

	const examenes =
		examenesSnap.docs.map(
			(d) => d.data()
		);

	const diagnostico =
		progresoTemas.map(
			(progreso) => {

				const tema =
					temas.find(
						(t) =>
							Number(t.ID) ===
							Number(
								progreso.temaId
							)
					);

				const correctas =
					progreso.correctas || 0;

				const incorrectas =
					progreso.incorrectas || 0;

				const total =
					correctas +
					incorrectas;

				const dominio =
					total > 0
						? Math.round(
							(correctas /
								total) *
								100
						)
						: 0;

				// =====================
				// Dependientes
				// =====================

				const dependientes =
					temas.filter(
						(t) =>
							Array.isArray(
								t.Prerrequisitos
							) &&
							t.Prerrequisitos.includes(
								progreso.temaId
							)
					).length;

				// =====================
				// Componentes
				// =====================

				const relacion =
					temaComponentes.find(
						(tc) =>
							Number(
								tc.TemaID
							) ===
							Number(
								progreso.temaId
							)
					);

				const componentesTema =
					(relacion?.Componentes || [])
						.map(
							(compId) => {

								const componente =
									componentes.find(
										(c) =>
											Number(
												c.ID
											) ===
											Number(
												compId
											)
									);

								if (
									!componente
								) {
									return null;
								}

								const examen =
									examenes.find(
										(e) =>
											Number(
												e.ID
											) ===
											Number(
												componente.ExamenID
											)
									);

								return {

									examen:
										examen?.Examen ||

										"",

									componente:
										componente
											.Componente
								};
							}
						)
						.filter(Boolean);

				const prioridad =
					(100 - dominio) +
					(dependientes * 20);

				return {

					temaId:
						progreso.temaId,

					tema:
						tema?.Tema || "",

					materia:
						tema?.Materia || "",

					macrotema:
						tema?.Macrotema || "",

					dominio,

					estado:
						calcularEstado(
							dominio
						),

					tendencia:
						calcularTendencia(
							progreso
								.ultimosResultados
						),

					dependientes,

					prioridad,

					componentes:
						componentesTema,

					prerequisitos:
						tema
							?.Prerrequisitos ||
						[]
				};
			}
		);

	return diagnostico.sort(
		(a, b) =>
			b.prioridad -
			a.prioridad
	);
};